import styled from 'styled-components'
import { animated } from '@react-spring/web'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

interface PercentProps {
  points: number
}

export const Container = styled.div<{ $top?: number; $isHeaderFullBorderRadius?: boolean }>`
  display: block;
  user-select: none;
  position: sticky;
  width: 100%;
  top: ${({ $top }) => $top || 0}px;
  background-color: ${Colors.White};
  z-index: 2;
  border-radius: ${props => (props.$isHeaderFullBorderRadius ? '12px' : '0px 0px 12px 12px')};

  ${Media.Phone`
    width: 100%;
    &:before,
    &:after {
      width: 20px;
    }
  `};

  &:before {
    right: 100%;
  }

  &:after {
    left: 100%;
  }
`

export const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  height: 56px;
  max-width: 100%;
  overflow: hidden;
  padding: 0 36px;
  justify-content: space-between;
  align-items: center;

  ${Media.Phone`
    padding: 20px;
  `};
`

export const HeaderMain = styled.div`
  display: flex;
  flex: 0 1 auto;
  overflow: hidden;
`

export const HeaderText = styled.p`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
  display: block;
  max-width: 180px;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const HeaderAside = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  overflow: hidden;
`

export const Percent = styled(animated.div)<PercentProps>`
  display: inline-block;
  ${Typography.Tiny};
  ${FontWeights.DemiBold}
  border-radius: 4px;
  margin-right: 8px;
  color: ${Colors.White};
  font-variant-numeric: tabular-nums;
  width: fit-content;
  height: 20px;
  padding: 2px 4.5px;
  ${({ points }) => {
    switch (true) {
      case points > 70:
        return `
          background-color: ${Colors.Green40};
        `
      case points > 30:
        return `
          background-color: ${Colors.Amber40};
        `
      default:
        return `
          background-color: ${Colors.Red40};
        `
    }
  }}

  &:after {
    content: '%';
  }
`

export const Progress = styled.div`
  height: 3px;
  background-color: ${Colors.Neutral10};
`

export const ProgressInner = styled(animated.div)`
  height: 3px;
  width: 100%;
  transform-origin: left;
`

export const PercentSuggestion = styled(animated.div)`
  display: flex;
  justify-content: center;
  align-content: center;
  ${Typography.Caption};
  font-size: 14px;
  font-weight: 400;
  color: ${Colors.Green60};
  background-color: ${Colors.Green10};
  font-variant-numeric: tabular-nums;
  border-radius: 4px;
  min-width: 32px;
  &:after {
    content: '%';
  }
`

export const Suggestion = styled.div`
  display: flex;
  gap: 8px;
  cursor: pointer;
  width: 100%;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${Typography.Caption};

  &:hover {
    color: ${Colors.Blue50};
  }

  &:hover ${PercentSuggestion} {
    color: ${Colors.Blue50};
  }
`
